(function () {
  // Classic, non-module, render-blocking script — placed directly after the
  // tilt carousel's markup in sections/tilt-carousel.liquid. Runs
  // synchronously during HTML parsing (no defer/async/type=module), so
  // Keen Slider initializes and applies its layout (min-width, transform)
  // before the browser paints, at the cost of blocking the rest of the
  // page's parse until this + keen-slider-umd.js have downloaded and run.
  var sliderElement = document.querySelector('.tilt-carousel:not([data-tilt-carousel-init])');
  if (!sliderElement) return;
  sliderElement.setAttribute('data-tilt-carousel-init', 'true');

  var autoplaySpeed = parseInt(sliderElement.dataset.autoplaySpeed || 4) * 1000;

  var autoplayInterval = null;
  var animation = { duration: 500, easing: (t) => t };
  var autoplayForward = true;
  var carouselOnScreen = true;

  var slides = sliderElement.querySelectorAll('.keen-slider__slide');
  var lastAppliedVisual = new WeakMap();

  function updateWheelEffect(slider) {
    if (!slider.track || !slider.track.details) return;

    var details = slider.track.details;

    slides.forEach(function (slide, index) {
      var slideInner = slide.querySelector('.slide-inner');
      var slideProgress = details.slides[index];
      if (!slideProgress) return;

      var distance = slideProgress.distance;
      var absDistance = Math.abs(distance);

      var scale, opacity, translateY, angle;

      if (absDistance <= 0.3) {
        scale = 1.5 - absDistance * 0.2;
        opacity = 1;
        translateY = absDistance * 5;
        angle = distance * 15;
        slide.classList.add('is-active');
        slide.classList.remove('is-inactive', 'is-near-active');
      } else if (absDistance <= 0.8) {
        scale = 0.9;
        opacity = 0.85;
        translateY = 12;
        angle = distance * 40;
        slide.classList.add('is-near-active');
        slide.classList.remove('is-active', 'is-inactive');
      } else {
        scale = 0.9;
        opacity = 0.85;
        translateY = 12;
        angle = distance * 20;
        slide.classList.add('is-inactive');
        slide.classList.remove('is-active', 'is-near-active');
      }

      var transform = 'translateY(' + translateY + 'px) rotate(' + angle + 'deg) scale(' + scale + ')';
      var prev = lastAppliedVisual.get(slideInner);
      if (prev && prev.transform === transform && prev.opacity === opacity) {
        return;
      }

      // blur is only ever 0 or 0.9 and tracks the is-active/is-near-active/
      // is-inactive classes set above, so it lives in CSS now. Writing a filter
      // on every frame forced the compositor to rebuild each slide's blur.
      slideInner.style.transform = transform;
      slideInner.style.opacity = opacity;
      lastAppliedVisual.set(slideInner, { transform: transform, opacity: opacity });
    });
  }

  function startAutoplay(slider) {
    stopAutoplay();
    if (document.hidden || !carouselOnScreen) return;
    autoplayInterval = setInterval(function () {
      var next = autoplayForward ? slider.track.details.abs + 1 : slider.track.details.abs - 1;
      slider.moveToIdx(next, true, animation);
    }, autoplaySpeed);
  }

  function stopAutoplay() {
    if (autoplayInterval) clearInterval(autoplayInterval);
    autoplayInterval = null;
  }

  // Only animate while the carousel is actually on screen and the tab is in the
  // foreground. Previously the 4s timer kept firing transform/opacity writes on
  // six slides for the entire life of the page.
  function watchVisibility(slider) {
    function sync() {
      if (carouselOnScreen && !document.hidden) startAutoplay(slider);
      else stopAutoplay();
    }

    if (typeof IntersectionObserver === 'function') {
      new IntersectionObserver(function (entries) {
        carouselOnScreen = entries.some(function (entry) {
          return entry.isIntersecting;
        });
        sync();
      }).observe(sliderElement);
    }

    document.addEventListener('visibilitychange', sync);
  }

  new window.KeenSlider(sliderElement, {
    loop: true,
    mode: 'snap',
    slides: {
      origin: 'center',
      renderMode: 'performance',
      perView: 1.8,
      spacing: 20,
    },
    created: function (slider) {
      sliderElement.classList.add('is-loaded');
      updateWheelEffect(slider);
      watchVisibility(slider);
      startAutoplay(slider);
    },
    detailsChanged: function (slider) {
      updateWheelEffect(slider);
    },
    destroyed: function () {
      stopAutoplay();
    },
  });
})();
